import { EnterpriseSearchService, ServiceType } from '@sabstravtech/obtservices/angular';
import { Input } from '@angular/core';

export class ProductLoadingScreen<T> {
  searchParams: T;
  constructor(
    public searchService: EnterpriseSearchService,
    params: T
  ) {
    this.searchParams = params;
  }
}
